<template>
  <div>
    <mahjongways v-if="prefix === 'MAHJONGWAYS'" :data="resultData" :tranID="tranId" @fetchResult="handleFetchResult"
      :key="componentKey" :lang="$i18n.locale" />
    <mahjongways2 v-if="prefix === 'MAHJONGWAYS2'" :data="resultData" :tranID="tranId" @fetchResult="handleFetchResult"
      :key="componentKey" :lang="$i18n.locale" />
    <aztec v-if="prefix === 'AZTEC'" :data="resultData" :tranID="tranId" @fetchResult="handleFetchResult"
      :key="componentKey" :lang="$i18n.locale" />
    <luckyneko v-if="prefix === 'LUCKYNEKO'" :data="resultData" :tranID="tranId" @fetchResult="handleFetchResult"
      :key="componentKey" :lang="$i18n.locale" />
    <wildbandito v-if="prefix === 'WILDBANDITO'" :data="resultData" :tranID="tranId" @fetchResult="handleFetchResult"
      :key="componentKey" :lang="$i18n.locale" />
    <wayofqilins v-if="prefix === 'QILIN'" :data="resultData" :tranID="tranId" @fetchResult="handleFetchResult"
      :key="componentKey" :lang="$i18n.locale" />
    <wildbountyshowdown v-if="prefix === 'WBSHOWDOWN'" :data="resultData" :tranID="tranId"
      @fetchResult="handleFetchResult" :key="componentKey" :lang="$i18n.locale" />
    <fortunerabbit v-if="prefix === 'FORTUNERABBIT'" :data="resultData" :tranID="tranId"
      @fetchResult="handleFetchResult" :key="componentKey" :lang="$i18n.locale" />
    <fortuneox v-if="prefix === 'FORTUNEOX'" :data="resultData" :tranID="tranId" @fetchResult="handleFetchResult"
      :key="componentKey" :lang="$i18n.locale" />
    <caishenwins v-if="prefix === 'CAISHENWINS'" :data="resultData" :tranID="tranId" @fetchResult="handleFetchResult"
      :key="componentKey" :lang="$i18n.locale" />
  </div>
</template>

<script>
import { FETCH_WINLOSE_RESULT_REQUEST } from "../store/actions/report";
import mahjongways from "./resultGame/mahjongway.vue";
import mahjongways2 from "./resultGame/mahjongway2.vue";
import aztec from "./resultGame/treaseure-aztec.vue";
import luckyneko from "./resultGame/lucky-neko.vue";
import wildbandito from "./resultGame/wildbandito.vue";
import wayofqilins from "./resultGame/wayofqilins.vue"
import wildbountyshowdown from "./resultGame/wildbountyshowdown.vue";
import fortunerabbit from "./resultGame/fortunerabbit.vue";
import fortuneox from "./resultGame/fortuneox.vue";
import caishenwins from "./resultGame/caishenwins.vue";

export default {
  name: "result-game",
  components: {
    mahjongways,
    mahjongways2,
    aztec,
    luckyneko,
    wildbandito,
    wayofqilins,
    wildbountyshowdown,
    fortunerabbit,
    fortuneox,
    caishenwins
  },
  data() {
    return {
      roundId: this.$route.query.roundId,
      tranId: this.$route.query.tranId,
      lang: this.$route.query.lang,
      timestamp: this.$route.query.timestamp,
      fId: this.$route.query.fId,
      errorModel: {
        code: 0,
        message: "",
      },
      resultHeaderModel: {
        prefix: "",
        level: "",
        room: "",
        roundId: "",
        roomId: "",
        createDate: "",
        updateDate: "",
      },
      resultData: {},
      prefix: "",
      arcadeData: {},
      gameType: "",
      componentKey: 0,
    };
  },
  created() {
    this.fetchResult();
  },
  methods: {
    handleFetchResult() {
      this.fetchResult();
    },
    closeWindow() {
      window.close();
    },
    async fetchResult() {
      let params = {
        roundId: this.roundId,
        timestamp: this.timestamp
      };
      if (this.fId) params[`fId`] = this.fId;
      await this.$store
        .dispatch(FETCH_WINLOSE_RESULT_REQUEST, params)
        .then((res) => {
          this.resultData = res;
          this.prefix = res[0].gamePrefix;
          this.$i18n.locale = res.lang;
          this.componentKey += 1;
        })
        .catch((err) => {
          this.errorModel.code = err.code;
          this.errorModel.message = err.message;
        });
    },
  },
};
</script>

<style lang="css">
.error-icon {
  font-size: 4.5rem;
  color: #e66060;
}

.error-msg {
  font-size: 1.3rem;
}
</style>
